import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from '../../helpers/apiInstance';
import actions from './actions';
import authActions from '../../redux/auth/actions';
import notificationActions from '../../redux/notifications/actions';
import { sendRequest } from '../../helpers/saga';
import { signInRoute } from '../../router';
import { t } from '../../i18n';

const loginWithSSOApi = new ApiInstance('one_time_token/sign_in');

function* loginWithSSORequest({ payload }) {
  const result = yield call(sendRequest, loginWithSSOApi.post, { data: payload }, notificationActions.REQUEST_ERROR);

  if (result?.status === 200) {
    const {
      user: {
        auth_token,
        id,
        time_zone,
        state,
        role,
        intercom,
        avatar_url,
        countries,
        first_name,
        last_name,
        selected_country: selectedCountry,
      },
    } = result.data;
    const avatarUrl = (avatar_url && avatar_url !== 'nophoto' ? avatar_url : '') || '';

    yield put(actions.loginWithSSOSuccess());
    yield put(
      authActions.loginSuccess({
        authToken: auth_token,
        isLoggedIn: !!auth_token,
        id,
        time_zone,
        state,
        role,
        profile: { name: first_name, lastName: last_name, avatar_url: avatarUrl },
        intercom,
        countries,
        selectedCountry,
      }),
    );
  } else {
    yield put(push(signInRoute));
    yield put(actions.loginWithSSOError());
    yield put(
      notificationActions.addNotification({
        headline: t('dash.common.notification.error_headline'),
        type: 'error',
        message: result?.messages?.[0],
      }),
    );
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOGIN_WITH_SSO_REQUEST, loginWithSSORequest)]);
}
